import React, { useCallback, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import axios from "axios";
import { HttpJsonHeader } from "../../features/Environments";

// table(components)
import BoostrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import { PageOptions } from "../components/PageParams";

// boostraps
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { Badge, Button, ListGroup } from "react-bootstrap";

import DateRangePicker from "@wojtekmaj/react-daterange-picker";

// icons

import { GoSearch } from "react-icons/go";

// sub form
import RadioResult from "./RadioResult";
// redux
import { useDispatch, useSelector } from "react-redux";
import { setReminder } from "../../features/UserActions";

//import SqlSearchTypeA from '../components/SqlSearchTypeA';
// import {BsFilePerson} from 'react-icons/bs';

import { EngDateFormatNoSplit, ThaiDate } from "../../core/ThaiDate";

import {
  FcCancel,
  FcComboChart,
  FcReadingEbook,
  FcTwoSmartphones,
} from "react-icons/fc";
import CapturedImageViewer from "../technician/CapturedImageViewer";
import ConfirmDialog from "../components/ConfirmDialog";
import {
  GetDatePreriod,
  GetHeaderStyle,
  GetImageStduyStatus,
  getCellStyle,
} from "../../core/Helper";
import Loading from "../../components/Loading";
import { SearchBar } from "../components/A04_SearchBar";

export default function RadioWorklistPassed() {
  const userDetail = useSelector((state) => state.user.detail);
  const scrollTop = useSelector((state) => state.scrollTrack.value.scTop);
  const dispatch = useDispatch();
  const [data, setData] = useState([]);

  const [showCtx, setShowCtx] = useState(false);
  const [showEditor, setShowEditor] = useState({ show: false });
  const [showScreenCapture, setShowScreenCapture] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [refData, setRefData] = useState([]);
  // const [captureResult, setCaptureResult] = useState(false);
  const [searchA, setSearchA] = useState({ show: false, action: () => {} });
  const [searchB, setSearchB] = useState({ show: false, action: () => {} });
  const [showImageView, setShowImageView] = useState(false);
  const [searchGood, setSearchGood] = useState({
    show: false,
    aciton: () => {},
  });
  const [updateFlag, setUpdateFlag] = useState(true);
  const [params, setParams] = useState({
    goodcateid: -1,
    gdmodid: -1,
    gdspecialtyid: -1,
    gdspcsubid: -1,
    custid: -1,
    custid_sender: -1,
    brchpatrightid: -1,
    price_list_id: -1,
  }); //* parameters สำหรับค้นหาสินค้าด้วย รหัสสินค้ากับรหัสสิทธิรักษา  **/
  const [searchParams, setSearchParams] = useState(null);
  const [dateRangeValues, changeDateRange] = useState([new Date(), new Date()]);
  const [dateSelected, setDateSelected] = useState(1);

  // Confirm
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);

  // selectionMode
  const [ctxMode, setCtxMode] = useState("complete");
  const [loading, setLoading] = useState(false);

  const refMouse = useRef();
  const refTable = useRef();

  const handleContextMenu = (e) => {
    if (selectedRow !== null) {
      setShowCtx(true);
    }
    e.preventDefault();
  };

  useEffect(() => {
    if (showEditor.show === false) {
      getData();
    }
  }, [dateRangeValues]);

  // ---------------------------------------------------------------------
  useEffect(() => {
    if (showEditor.show === false) {
      document.addEventListener("contextmenu", handleContextMenu);
    } else {
      document.removeEventListener("contextmenu", handleContextMenu);
    }
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, [showEditor, selectedRow]);
  // ---------------------------------------------------------------------
  useEffect(() => {
    if (updateFlag) {
      getData();
      setUpdateFlag(false);
    }
  }, [updateFlag]);
  // ---------------------------------------------------------------------
  // ** receive study components data {patient-right, }..
  useEffect(() => {
    /**Remove mousedown event*/

    axios
      .post(
        process.env.REACT_APP_API + "api/studyinfo/getComponents",
        { BrchId: userDetail.brchid },
        HttpJsonHeader
      )
      .then((res) => {
        setRefData(res.data);
      })
      .catch((err) => remindError(err));

    return () => {
      console.log("Radipass said: removing");
      document.removeEventListener("dblclick", () => {});
    };
  }, []);
  // ---------------------------------------------------------------------
  // useEffect(() => {
  //   // console.log(searchParams);
  // }, [searchParams]);

  useEffect(() => {
    setPreriod("LAST7DAYS", 2);
  }, []);

  const formatEngDMY = (value) => {
    let tmp = value.toLocaleDateString(); // m/d/y
    let m = tmp.split("/");
    return (
      m[2] +
      "-" +
      m[0].substr(m[0].length - 2) +
      "-" +
      m[1].substr(m[1].length - 2)
    );
  };

  // ---------------------------------------------------------------------
  const getData = () => {
    setLoading(true);
    axios
      .post(
        process.env.REACT_APP_API +
          "api/studyinfo/list-studies-radiologist-completed",
        {
          UserInfo: userDetail,
          DateRange: [
            EngDateFormatNoSplit(dateRangeValues[0]),
            EngDateFormatNoSplit(dateRangeValues[1]),
          ],
          SearchInfo: searchParams,
        },
        HttpJsonHeader
      )
      .then((response) => {
        setLoading(false);
        setData(response.data.Completed_result);
      })
      .catch((err) => {
        setLoading(false);
        remindError(err);
      });
  };
  // ---------------------------------------------------------------------
  const remindError = (msg) => {
    dispatch(setReminder({ show: true, message: msg.message, type: "error" }));
  };
  // ---------------------------------------------------------------------
  const formatFinal = (x, row) => {
    return <FcCancel style={{ width: "40px", height: "40px" }} />;
  };
  // ---------------------------------------------------------------------
  const customTextFilter = {
    placeholder: "...",
  };
  // ---------------------------------------------------------------------
  // const getHeaderStyle = (wi) => {
  //   return {
  //     width: wi,
  //     background: "var(--table-header-back-color)",
  //     color: "var(--select-item-color)",
  //   };
  // };
  // ---------------------------------------------------------------------
  const getDateFormat = (cell, row) => {
    return <ThaiDate dateValue={cell} />;
  };
  // ---------------------------------------------------------------------
  const getTimeFormat = (cell, row) => {
    return <div>{cell}</div>;
  };

  const formatStatus = (cell, row) => {
    return <GetImageStduyStatus id={row.action_id} />;
  };
  // ---------------------------------------------------------------------
  // study_date",
  const columns = [
    {
      dataField: "study_date",
      text: "Date",
      sort: true,
      headerStyle: () => GetHeaderStyle("120px"),
      style: getCellStyle("center"),
      filter: textFilter(customTextFilter),
      formatter: getDateFormat,
    },
    {
      dataField: "study_time",
      text: "Time",
      sort: true,
      headerStyle: () => GetHeaderStyle("100px"),
      style: getCellStyle("center"),
      filter: textFilter(customTextFilter),
      formatter: getTimeFormat,
    },
    {
      dataField: "patientid",
      text: "HN",
      sort: true,
      headerStyle: () => GetHeaderStyle("120px"),
      style: getCellStyle("center"),
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "patients_name",
      text: "ชื่อ-สกุล ผู้ป่วย",
      sort: true,
      headerStyle: () => GetHeaderStyle("auto"),
      style: getCellStyle("center"),
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "patients_sex",
      text: "เพศ",
      sort: true,
      headerStyle: () => GetHeaderStyle("100px"),
      style: getCellStyle("center"),
      filter: textFilter(customTextFilter),
      formatter: (cell, row) => {
        return `${cell === "M" ? "ชาย" : "หญิง"}`;
      },
    },
    {
      dataField: "modality",
      text: "Modality",
      sort: true,
      headerStyle: () => GetHeaderStyle("80px"),
      style: getCellStyle("center"),
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "physician_staff_name",
      text: "แพทย์เจ้าของไข้",
      sort: true,
      headerStyle: () => GetHeaderStyle("auto"),
      style: getCellStyle("center"),
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "study_description",
      text: "Description",
      sort: true,
      headerStyle: () => GetHeaderStyle("auto"),
      style: getCellStyle("center"),
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "accession_number",
      text: "Accession Number",
      sort: true,
      headerStyle: () => GetHeaderStyle("auto"),
      style: getCellStyle("center"),
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "action_event",
      text: "สถานะ",
      headerStyle: () => GetHeaderStyle("160px"),
      style: getCellStyle("center"),
      formatter: formatStatus,
      align: "center",
    },
    // {
    //   dataField: "FinalDiag",
    //   text: "Final Diag.",
    //   headerStyle: () => getHeaderStyle("50px"),
    //   formatter: formatFinal,
    //   align: "center",
    // },
  ];

  // --------------------------------------
  const showEditorAction = () => {
    setShowEditor({
      show: false,
      action: () => {
        setShowEditor({ show: true });
        setShowCtx(false);
      },
    });
  };

  // --------------------------------------

  // --------------------------------------
  const getContextMenuCondition = () => {
    if (ctxMode === "complete") {
      return (
        <ListGroup style={{ margin: "0 0 0 0px" }}>
          <ListGroup.Item
            style={styles.listItem}
            action
            variant="light"
            onClick={() => {
              showEditorAction();
            }}
          >
            <FcReadingEbook style={styles.icon} /> รายละเอียด
          </ListGroup.Item>

          <ListGroup.Item style={styles.listItem} action variant="light">
            <FcTwoSmartphones style={styles.icon} />
            ลบจากประวัติ
          </ListGroup.Item>
        </ListGroup>
      );
    }
  };
  // --------------------------------------
  const popover = (
    <Popover id="popover-basic" style={{ minWidth: "300px" }}>
      <Popover.Header
        style={{ background: "#1907a2", color: "#f4f4ff" }}
        as="h3"
      >
        เลือกรายการ
      </Popover.Header>
      <Popover.Body style={{ pading: "0 0 0 0px" }}>
        {getContextMenuCondition()}
      </Popover.Body>
    </Popover>
  );

  const selectRow = {
    mode: "radio",
    clickToSelect: true,
    classes: "row-h-over-selected",
    hideSelectColumn: true,
    onSelect: (row, isSelect, rowIndex, e) => {
      // .. use MotionBox dummy object to invoke a ContextMenu to be show acordingly mouse position //
      refMouse.current.style.left = `${e.clientX - 7}px`;
      refMouse.current.style.top = `${scrollTop + e.clientY - 7}px`;
    },
  };
  // --------------------------------------
  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      setSelectedRow(row);
    },
    onDoubleClick: (e, row, rowIndex) => {
      // setSelectedRow(row);
      showEditorAction();
    },
    onMouseEnter: (e, row, rowIndex) => {
      setShowCtx(false);
    },
    onMouseMove: (e, row, rowIndex) => {
      refMouse.current.style.left = `${e.clientX - 7}px`;
    },
  };

  const setPreriod = (dateStyle, index) => {
    changeDateRange(GetDatePreriod(dateStyle));
    setDateSelected(index);
  };

  const getBadge = () => {
    return <Badge>{data && data.length}</Badge>;
  };

  return (
    <div>
      {loading ? <Loading /> : <></>}
      <OverlayTrigger show={showCtx} placement="right" overlay={popover}>
        <MotionBox ref={refMouse} />
      </OverlayTrigger>

      <div className="table-caption-box-right-flex">{"ประวัติการวินิจฉัย"}</div>

      {/* ---------------------------------------------------------------------------------------- */}
      {/* <HBox>
        <VBox>
          <HBox>
            <HBox style={{ paddingLeft: "3px" }}>
              <Button
                variant={dateSelected === 1 ? "danger" : "info"}
                style={{ margin: "2px", minWidth: "120px" }}
                onClick={() => setPreriod("TODAY", 1)}
              >
                Today
              </Button>
              <Button
                variant={dateSelected === 2 ? "danger" : "info"}
                style={{ margin: "2px", minWidth: "120px" }}
                onClick={() => setPreriod("LAST7DAYS", 2)}
              >
                Last 7 Days
              </Button>
              <Button
                variant={dateSelected === 3 ? "danger" : "info"}
                style={{ margin: "2px", minWidth: "120px" }}
                onClick={() => setPreriod("THISMONTH", 3)}
              >
                This Month
              </Button>
              <Button
                variant={dateSelected === 4 ? "danger" : "info"}
                style={{ margin: "2px", minWidth: "120px" }}
                onClick={() => setPreriod("LAST3M", 4)}
              >
                Last 3 Months
              </Button>
            </HBox>

            <HBox style={{ flex: "1", color: "#81ecb9", padding: "5px" }}>
              <span style={{ padding: "5px" }}>ระหว่างวันที่ :</span>
              <span style={{ minWidth: "300px" }}>
                <DateRangePicker
                  onChange={changeDateRange}
                  value={dateRangeValues}
                  format="dd/MM/yyyy"
                  locale="th-Th"
                  clearIcon={null}
                />
              </span>
              <span>
                <Button
                  variant="dark"
                  style={{
                    flex: "1",
                    borderRadius: "30px 30px",
                    margin: "0px",
                  }}
                  onClick={() => {
                    getData();
                  }}
                >
                  <GoSearch
                    style={{ width: "15px", height: "20px", color: "white" }}
                  />
                </Button>
              </span>
            </HBox>
          </HBox>
        </VBox>
      </HBox> */}
      <SearchBar callback={(e) => {}} />
      {/* ---------------------------------------------------------------------------------------- */}
      <BoostrapTable
        bootstrap4
        keyField="pacs_study_id"
        rowClasses={"table-next-rows-style"}
        data={data}
        columns={columns}
        striped
        hover
        condensed
        headerWrapperClasses="headerWrapper"
        wrapperClasses="worklist-table-wrapper"
        bordered={true}
        pagination={paginationFactory(PageOptions)}
        filter={filterFactory()}
        rowEvents={rowEvents}
        selectRow={selectRow}
        ref={refTable}
      />

      {/* <RadioResult
        {...{
          editor: [showEditor, setShowEditor],
          showCtx: [showCtx, setShowCtx],
          userDetail,
          setShowEditor,
          selectedRow,
          setShowCtx,
          refData,
          showScreenCapture,
          setShowScreenCapture,
          searchState: [searchA, setSearchA],
          showImage: [showImageView, setShowImageView],
          searchGood: [searchGood, setSearchGood],
          searchB: [searchB, setSearchB],
          params: [params, setParams],
          updateFlag: [updateFlag, setUpdateFlag],
          enableSave: true,
          enablePrint: true,
          template: [null, null],
          loading: [loading, setLoading],
        }}
      /> */}
      <CapturedImageViewer
        {...{ showImage: [showImageView, setShowImageView] }}
      />
      <ConfirmDialog
        {...{ showConfirm, setShowConfirm, confirmAction, setConfirmAction }}
      />
    </div>
  );
}

const MainBox = styled.div`
  min-width: ${(props) => props.win_width}px;
  height: 100vh;
  overflow-x: scroll;
`;

const MotionBox = styled.div`
  position: absolute;
  top: 100px;
  left: 100px;
  height: 15px;
  width: 15px;
  background-color: transparent;
  z-index: -2;
`;

const HBox = styled.div`
  display: flex;
`;

const VBox = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const SBox = styled.div`
  color: white;
  margin: 5px;
  flex: 1;
`;

const styles = {
  icon: { color: "#2731ff", marginRight: "5px", width: "30px", height: "30px" },
  listItem: { color: "#fb4204" },
};

const TabDiv = styled("Tabs")`
  color: "white";
`;
